export const FAQPage = "/faq";
